import type { ConfigOptions } from 'antd/lib/message/interface'

export const messageConfig: ConfigOptions = {
  top: 6,
  maxCount: 3,
  duration: 2
}
